import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  return (
    <nav aria-label="栏目切换" className="flex flex-wrap gap-2">
      {categories.map((item) => {
        const active = item.slug === activeSlug;
        return (
          <Link
            key={item.slug}
            to={`/category/${item.slug}`}
            aria-current={active ? 'page' : undefined}
            className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
              active
                ? 'bg-primary-500 font-medium text-background-950'
                : 'border border-background-300/70 text-foreground-400 hover:border-primary-500/50 hover:text-primary-300'
            }`}
          >
            <i className={`${item.icon} text-base`}></i>
            {item.name}
          </Link>
        );
      })}
    </nav>
  );
}